function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M18.3 3s1.841 14.191.664 17.723C16.062 29.429 19 33 19.405 47.475c.14 1.446-1.758 4.924-.052 6.087 1.706 1.163 3.309-.014 4.35-.132 1.81-.205 3.053-.056 4.836.322.848.18 1.522.493 2.388.467.762-.024 1.312-.706 2.073-.762.682.352 1.347.607 2.047.436.626-.153 1.676-.665 1.676-1.33 0-.332-.312-.516-.994-.516-.227 0-1.054.048-1.28.027-1.266-.118-1.993-.503-3.077-1.189-4.855-3.068-6.247-2.045-6.22-4.83C24.713 34.823 26.207 24.62 26.5 23c.285-2.605 1.5-3 1.5-6l1-14M21.525 47.347c-1.274 2.155.945 2.293.946 2.293",
  fill: "none",
  stroke: "var(--primary-color, #000)",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgLeg = function SvgLeg(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLeg, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Leg.7e4e80ce.svg";
export { ForwardRef as ReactComponent };